import * as React from 'react';

const TargetArrow24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M20.073 1.768a.768.768 0 0 0-1.311-.543L16.567 3.42a.77.77 0 0 0-.226.543v2.609l-5.92 5.921a.768.768 0 0 0 1.086 1.087l5.921-5.921h2.609a.77.77 0 0 0 .543-.225l2.195-2.196a.768.768 0 0 0-.543-1.311h-2.159z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.963 5.61a7.427 7.427 0 1 0 7.427 7.427.768.768 0 0 1 1.537 0 8.963 8.963 0 1 1-8.964-8.964.768.768 0 0 1 0 1.537"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.963 9.707a3.33 3.33 0 1 0 3.33 3.33.768.768 0 1 1 1.536 0 4.866 4.866 0 1 1-4.866-4.866.768.768 0 0 1 0 1.536"
  }
));
TargetArrow24.Size = 24;
TargetArrow24.Title = "TargetArrow";

export { TargetArrow24 as default };
